"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'ai.assist.attachKnowledge': 'Dołącz Wiedzę:',
    'ai.assist.knowledgeFound': 'Znaleziono odpowiednią wiedzę',
    'ai.assist.relevantKnowledgeFound': 'Znaleziono odpowiednią wiedzę po rozmowie',
    'ai.assist.attachmentIds': 'ID załączników',
};
